import { getJson } from "./networkService";

export async function getDashboard(accountNumber) {
  return getJson(`/clients/${accountNumber}/dashboard`);
}

export async function getMultiClientDashboard(email) {
  return getJson(`/clients/dashboard/${email}`);
}
